export default __webpack_public_path__ + "static/media/August2018.1d85e52d.png";